import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './index.css'
import { Icon } from '@iconify/react'
import BrandLogo from '../BrandLogo'
import { useAppDispatch } from '../../redux/hook'
import { LOGOUT } from '../../redux/slices/authSlice'
import { PageRoute } from '../../routes'
import Modal from '../Modal'
import { useTranslation } from 'react-i18next'
import { Button } from 'react-bootstrap'
import { User } from '../../features/auth/slice/userSlice'

const SideNavbar: React.FC = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [showModal, setShowModal] = React.useState(false)
    const location = window.location.pathname
    const navItems = [
        {
            to: '/dashboard',
            label: `${t('sidebar.dashboard')}`,
            icon: <Icon icon="radix-icons:dashboard" />,
        },
        {
            to: '/profile',
            label: `${t('sidebar.profile')}`,
            icon: <Icon icon="iconamoon:profile" />,
        },
        {
            to: '/leave-policies',
            label: `${t('sidebar.leavePolicies')}`,
            icon: <Icon icon="mdi:human-male-board" />,
        },
        {
            to: '/emp/files',
            label: `Employee Files`,
            icon: <Icon icon="gravity-ui:exclamation-shape" />,
        },

        {
            to: '/announcements',
            label: `${t('sidebar.announcements')}`,
            icon: <Icon icon="mdi:announcement-outline" />,
        },
        {
            to: '/users',
            label: `${t('sidebar.users')}`,
            icon: <Icon icon="ph:users" />,
        },
        {
            to: '/resources',
            label: `Training Programs`,
            icon: <Icon icon="gg:list" />,
        },
        {
            to: '/forms',
            label: `Forms`,
            icon: <Icon icon="gg:list" />,
        },
        {
            to: '/sync',
            label: `Sync Calendar`,
            icon: <Icon icon="gg:list" />,
        },
        {
            to: '/timeoffreq',
            label: `${t('sidebar.timeOffRequests')}`,
            icon: <Icon icon="tdesign:calendar-1" />,
        },
        {
            to: '/holidays',
            label: `${t('sidebar.holidays')}`,
            icon: <Icon icon="material-symbols:holiday-village-outline" />,
        },
    ]
    const handleLogout = () => {
        setShowModal(true)
    }

    return (
        <>
            <nav
                id="sidebarMenu"
                className={`col-md-3 col-lg-2 d-md-block bg-light sidebar`}
            >
                <div className="custom-modal">
                    <Modal
                        onSuccess={() => {
                            setShowModal(false)
                            dispatch(LOGOUT())
                            navigate(PageRoute.Logout)
                            dispatch(
                                User({
                                    role: '',
                                    firstName: '',
                                    email: '',
                                    id: '',
                                    lastName: '',
                                })
                            )
                        }}
                        title={'Hey User'}
                        body={
                            <>
                                <div className="text-center mb-5 mt-2">
                                    Are you sure you want to logout?
                                </div>

                                <div className="footer-block mb-3">
                                    <Button
                                        onClick={() => {
                                            setShowModal(false)
                                            dispatch(LOGOUT())
                                            dispatch(
                                                User({
                                                    role: '',
                                                    firstName: '',
                                                    email: '',
                                                    id: '',
                                                    lastName: '',
                                                })
                                            )
                                            navigate(PageRoute.Logout)
                                        }}
                                    >
                                        YES
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="outline-success"
                                        onClick={() => setShowModal(false)}
                                    >
                                        NO
                                    </Button>
                                </div>
                            </>
                        }
                        show={showModal}
                        handleClose={() => {
                            setShowModal(false)
                        }}
                    />
                </div>
                <BrandLogo />

                <div className="position-sticky position-sticky-custom">
                    <ul className="nav flex-column mt-3 nav-custom">
                        {navItems.map((item, index) => (
                            <li
                                className={`nav-item ${location.includes(item.to) && 'active'}`}
                                key={index}
                            >
                                <Link className="nav-link" to={item.to}>
                                    {item?.icon} {item.label}
                                </Link>
                            </li>
                        ))}
                        <li className="nav-item logout">
                            <Link
                                className="nav-link"
                                to="#"
                                onClick={handleLogout}
                            >
                                <Icon icon="majesticons:logout-line" />{' '}
                                {t('sidebar.logout')}
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}

export default SideNavbar
